import {offerPriceAsc, offerPriceDesc, priceAsc, priceDesc} from '~/utils/sort-helpers'

export const sortOffersInsideProduct = {
    priceAsc: product => {
        product.offers?.sort(offerPriceAsc)
    },
    priceDesc: product => {
        product.offers?.sort(offerPriceDesc)
    },
    dateAsc: product => {
        sortOffersInsideProduct.priceAsc(product)
        product.offers?.sort((a, b) => {
            return new Date(a.date).getTime() - new Date(b.date).getTime()
        })
    },
}

export default function (products, sortFnName) {
    const minDate = product =>
        Math.min.apply(
            null,
            product.offers.map(offer => new Date(offer.date))
        )
    const sortFn = {
        priceAsc,
        priceDesc,
        recommended: (offer1, offer2) => {
            let byRecommended = offer2.recommended - offer1.recommended
            return byRecommended === 0 ? sortFn.priceAsc(offer1, offer2) : byRecommended
        },
        favorites: (offer1, offer2) => {
            if (!offer1.wishlist && offer2.wishlist) return 1
            if (offer1.wishlist && !offer2.wishlist) return -1
            return 0
        },
        dateAsc: (product1, product2) => {
            if (minDate(product1) !== minDate(product2)) {
                return minDate(product1) - minDate(product2)
            } else {
                return sortFn.priceAsc(product1, product2)
            }
        },
    }

    products.forEach(product => {
        sortOffersInsideProduct[sortFnName]?.(product)
    })

    return products.concat().sort((offer1, offer2) => sortFn[sortFnName](offer1, offer2))
}
